export const currencyFormat = (value: number | string) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(Number(value || 0))
  /* $2,500.00 */
}

export const currencyFormatRp = (value?: number | string) => {
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter
    .format(Number(value || 0))
    .replace('IDR', 'Rp')
    .replace(',', '.')
    .replace(/\s/g, '')
}

export function currencyFormatWithoutRounding2Decimal(amount = '0', currency = 'Rp') {
  if (amount === null || amount === undefined || amount === '') {
    return currency ? `${currency} -` : ''
  }

  if (Number(amount) === -1) {
    return currency ? `${currency} ****` : '****'
  }

  const symbol = currency ?? 'Rp'
  const numberString = Number(amount).toString()
  const [integerPart, decimalPartRaw] = numberString.split('.')

  const formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  const decimal = decimalPartRaw ? decimalPartRaw.slice(0, 2).padEnd(2, '0') : '00'

  const prefix = symbol ? `${symbol} ` : ''
  const suffix = decimal !== '00' ? `,${decimal}` : ''

  return `${prefix}${formatted}${suffix}`
}
